import Vue from "vue";
import App from "./App.vue";
import store from "./store/index";
import router from "./router/index";
import VueBreadcrumbs from "vue-breadcrumbs";
import "./registerServiceWorker";
import * as commonFilters from "@/common/filters";
import UserHasFeature from "@/plugins/userHasFeature";
import Features from "@/common/feature-lib";
import vuetify from "@/plugins/vuetify";

// Import styles - order is important.
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@/styles/main.styl";

// for IE 11
import "./polyfills/cssvars";
import "./polyfills/CustomEvent";

Vue.config.productionTip = false;

Vue.use(VueBreadcrumbs);
Vue.use(UserHasFeature);

for (var i in commonFilters) Vue.filter(i, commonFilters[i]);

new Vue({
	store,
	router,
	vuetify,
	breadcrumbs: VueBreadcrumbs,
	beforeCreate: function() {
		Vue.prototype.$mhi = {
			...Features,
			userHasFeature: featureName => {
				return this.$store.getters["currentUserHasFeature"](featureName);
			},
			replaceLabel: labelText => {
				return this.$store.getters["replaceLabel"](labelText);
			}
		};
	},
	render: h => h(App)
}).$mount("#app");
